import { render, staticRenderFns } from "./CategorizationPaymentVG.vue?vue&type=template&id=fbc6d002"
import script from "./CategorizationPaymentVG.vue?vue&type=script&lang=js"
export * from "./CategorizationPaymentVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports